export function capitalizeString(string) {
   return string ? string.replace(/^\w/, c => c.toUpperCase()): ''; 
}
